var React = require('react');

function UptimeIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M298.068 0L0.0107422 34.0637H298.068V0Z","fill":"#C99CEF","key":0}),React.createElement("path",{"d":"M298.068 17.8835L0.00976562 34.0638H298.068V17.8835Z","fill":"white","key":1})]);
}

UptimeIconInline.defaultProps = {"width":"299","height":"35","viewBox":"0 0 299 35","fill":"none"};

module.exports = UptimeIconInline;

UptimeIconInline.default = UptimeIconInline;
